import { InjectionToken } from '@angular/core';

/**
 * Minimal interface for checking field-level read/update permissions.
 * Implemented by PermissionService from @zag/auth/ui.
 *
 * Using an InjectionToken allows buildable domain libraries (e.g. @zag/planning/ui)
 * to inject permission-checking without a direct source-level import of the
 * non-buildable @zag/auth/ui library (which cannot be resolved by ng-packagr).
 *
 * @example
 * // In app bootstrap / route providers:
 * { provide: FIELD_PERMISSION_CHECKER, useExisting: PermissionService }
 *
 * // In a library component:
 * private readonly permissions = inject(FIELD_PERMISSION_CHECKER);
 */
export interface FieldPermissionChecker {
  hasPermission(permission: string): boolean;
  hasAnyPermission(permissions: string[]): boolean;
  canReadField(resource: string, section?: string, field?: string): boolean;
  canUpdateField(resource: string, section?: string, field?: string): boolean;
}

export const FIELD_PERMISSION_CHECKER = new InjectionToken<FieldPermissionChecker>('FIELD_PERMISSION_CHECKER');
